export default (word, words) =>
  (word ? words.split(word).length - 1 : 0)



// WEBPACK FOOTER //
// ./src/helpers/matches.js